/*@ngInject*/
const GetAccountRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getAccountById = function (accountId) {
        const url = `/rest/Account/${accountId}`;

        return this.get(url);
    };

    this.synchronizeAccount = function (accountId) {
        const url = `/rest/Account/${accountId}/synchronize`;

        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('getAccountRepository', GetAccountRepository);
